module.exports = __webpack_public_path__ + "static/media/icon-edit-blue-clear.c6d7c4da.svg";